import React, { useState } from 'react';
import {useDispatch } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';
import NumberInput from "web/components/form-elements/NumberInput";
import { useHistory } from 'react-router-dom';
import { Form, Formik } from 'formik';
import Button from 'web/components/Button';
import {
  INITIAL_VALUES,
  VALIDATION_SCHEMA,
} from 'web/components/utils/purchasingLimitUtils';
import {
  purchasingLimit
} from 'redux/actions/accountSetting';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import AlertModal from 'web/components/AlertModal';
import styles from './purchasingLimit.module.scss';

const PurchasingLimit = ({ buttonName, locationType, handlePayment, locationId, pageLanguageContents }) => {
  const [forgotModal, forgoToggleModal] = useState(false);
  const dispatch = useDispatch();
  let history = useHistory();
  const token = localStorage.getItem('token');
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const toggleModal = () => setModal(!modal);
  const purchasingLimitHandler = async (props) => {
    let data = {
      amount: props.values.amount,
    };
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/sign-in');
      toggleModal();
    } else {
      const response = await dispatch(purchasingLimit(locationId, data, token));
      if (response.status === "SUCCESS") {
        forgoToggleModal(!forgotModal)
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
      } else {
        if (response.statusCode === 401) {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink('');
          toggleModal();
        }
      }
    }
  };

  return (
    <div className={styles.forgotPasswordContainer}>

      <Button
        type='app-green-button'
        disabled={locationType ? true : handlePayment ? true : false}
        handleClick={() => {
          forgoToggleModal(!forgotModal)
        }}>
        {pageLanguageContents !== undefined && pageLanguageContents.length !== 0 && pageLanguageContents[0].Location_Contents[10].Action_Box2}
      </Button>
      <Modal
        isOpen={forgotModal}
        toggle={() => forgoToggleModal(!forgotModal)}
        backdrop={'static'}
        centered={true}
        className={styles.forgotPassword}>
        <div className={styles.header}>
          <Button handleClick={() => forgoToggleModal(!forgotModal)}>
            <img src={CloseIcon} className="closeIcon" alt="close-icon" />
          </Button>
          <h3>
            {pageLanguageContents !== undefined && pageLanguageContents.length !== 0 && pageLanguageContents[0].Location_Contents[19].PurchasingLimit}
          </h3>
        </div>
        <ModalBody className={styles.body}>
          <Formik
            initialValues={INITIAL_VALUES}
            validationSchema={VALIDATION_SCHEMA}
            onSubmit={(values) => { }}>
            {(props) => {
              const { isValid, dirty } = props;
              return (
                <>
                  <Form>
                    <div className={styles.fieldGroup}>
                      <div className={styles.field}>
                        <p className={styles.inputLabel}>
                          {pageLanguageContents !== undefined && pageLanguageContents.length !== 0 && pageLanguageContents[0].Location_Contents[19].PurchasingLimit}<span className="star">*</span>
                        </p>
                        <NumberInput
                          name="amount"
                          maxLength={15}
                          placeholder={pageLanguageContents !== undefined && pageLanguageContents.length !== 0 && pageLanguageContents[0].Location_Contents[19].PurchasingLimit}
                        />
                      </div>
                    </div>
                    <div className={styles.footer}>
                      <Button
                        type="app-green-button"
                        handleClick={() => {
                          purchasingLimitHandler(props);
                        }}
                        disabled={!(isValid && dirty)}
                      >
                        {pageLanguageContents !== undefined && pageLanguageContents.length !== 0 && pageLanguageContents[0].Location_Contents[20].Submit}
                      </Button>
                    </div>
                  </Form>
                </>
              );
            }}
          </Formik>
        </ModalBody>
      </Modal>
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        content={modalContent}
        link={modalLink}
      />
    </div>
  );
};

export default PurchasingLimit;
